<template>
<div>
  <div class="hkjh">
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item :to="{ path: '/share/current' }">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>回款计划</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="proname">
      <div style="height: 32px;line-height: 32px">
        项目名称：<span style="font-weight: 700">{{proname}}</span>
      </div>
      <div>
        <el-button type="primary" class="btn-add" @click="comedit('row','new')">新增回款计划</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <el-table-column
        label="回款计划"
        prop="stage"
        align="center"
      >
        <template slot-scope="scope">
          第{{scope.row.stage}}笔
        </template>
      </el-table-column>
      <el-table-column
        label="回款金额（万）"
        prop="collection_amount"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="回款时间"
        prop="plan_time"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span @click="comedit(scope.$index, scope.row)" style="color:#347ae2;cursor: pointer;">修改</span>
          <span @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>

  </div>

  <div class="kpsj">
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item :to="{ path: '/share/current' }">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>开票时间</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="proname">
      <div style="height: 32px;line-height: 32px">
        项目名称：<span style="font-weight: 700">{{proname}}</span>
      </div>
      <div>
        <el-button type="primary" class="btn-add" @click="comedit2('row','new')">新增开票</el-button>
      </div>
    </div>

    <el-table
      :data="tableData2"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <el-table-column
        label=""
        prop="stage"
        align="center"
      >
        <template slot-scope="scope">
          第{{scope.row.stage}}笔
        </template>
      </el-table-column>
      <el-table-column
        label="开票金额（万）"
        prop="billing_amount"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="开票时间"
        prop="invoicing_date"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span class="caozuo"  @click="comedit2(scope.$index, scope.row)" style="color:#347ae2;cursor: pointer;">修改</span>
          <span class="caozuo"  @click="delColomn2(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="sjhk">
    <el-breadcrumb separator="/" class="top-div">
      <el-breadcrumb-item :to="{ path: '/share/current' }">项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>实际回款</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="proname">
      <div style="height: 32px;line-height: 32px">
        项目名称：<span style="font-weight: 700">{{proname}}</span>
      </div>
      <div>
        <el-button type="primary" class="btn-add" @click="comedit1('row','new')">新增实际回款</el-button>
      </div>
    </div>

<!--   实际回款表 -->
    <el-table
      :data="tableData1"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <el-table-column
        label="实际回款"
        prop="stage"
        align="center"
      >
                <template slot-scope="scope">
                  第{{scope.row.stage}}笔
                </template>
      </el-table-column>
      <el-table-column
        label="实际回款金额（万）"
        prop="collection_actual"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="回款时间"
        prop="collection_date"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span class="caozuo"  @click="comedit1(scope.$index, scope.row)" style="color:#347ae2;cursor: pointer;">修改</span>
          <span class="caozuo"  @click="delColomn1(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>


  </div>

  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="30%"
    class="diago"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" label-width="auto" :rules="rules">
      <el-form-item label="回款时间：" prop="plan_time">
        <!--        <el-input style="width:300px" v-model="form.plan_time" placeholder="请输入回款时间"></el-input>-->
        <el-date-picker
          v-model="form.plan_time"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:300px"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="计划回款：" prop="collection_amount">
        <el-input style="width:300px" v-model="form.collection_amount" placeholder="请输入金额（万）"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata" class="btn-submit1">确 定</el-button>
        </span>
  </el-dialog>
  <el-dialog
    class="diago"
    :title="form1.title"
    :visible.sync="dialogVisible1"
    width="30%"
    :close-on-click-modal="false"
  >
    <el-form ref="form1" :model="form1" label-width="auto" :rules="rules1">
      <el-form-item label="实际回款时间：" prop="collection_date">
        <!--        <el-input style="width:300px" v-model="form.plan_time" placeholder="请输入回款时间"></el-input>-->
        <el-date-picker
          v-model="form1.collection_date"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:300px"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="实际回款：" prop="collection_actual">
        <el-input style="width:300px" v-model="form1.collection_actual" placeholder="请输入金额（万）"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata1" class="btn-submit1">确 定</el-button>
        </span>
  </el-dialog>
  <el-dialog
    :title="title2"
    :visible.sync="dialogVisible2"
    width="30%"
    class="diago"
    :close-on-click-modal="false"
  >
    <el-form ref="form2" :model="form2" label-width="auto" :rules="rules2">
      <el-form-item label="开票时间：" prop="plan_time">
        <el-date-picker
          v-model="form2.plan_time"
          type="date"
          value-format="yyyy-MM-dd"
          style="width:300px"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="开票金额：" prop="collection_amount">
        <el-input style="width:300px" v-model="form2.collection_amount" placeholder="请输入金额"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata2" class="btn-submit1">确 定</el-button>
        </span>
  </el-dialog>



</div>
</template>



<script>
import {
  del_collection_plan,
  get_collection_plan,
  mod_collection_plan,
  create_collection_plan,
  create_collection_actual,
  get_collection_actual,
  mod_collection_actual,
  del_collection_actual, get_billing, mod_billing, create_billing, del_billing

} from "../../api/user";

export default {
  data(){
    return {
      project_id:'',
      proname:'',
      tableData:[],
      tableData1:[],
      tableData2:[],

    //  弹窗参数
      dialogVisible:false,
      title:'',
      form:{
        projectid:'',
        stage:'',
        collection_amount:'',
        plan_time:''
      },
      title1:'',
      rules: {
        plan_time: [
          { required: true, message: '请选择计划回款时间', trigger: 'change' }
        ],
        collection_amount: [
          { required: true, message: '请输入计划回款金额', trigger: 'change' }
        ],
      },

      //实际回款
      form1:{
        title:'',
        title1:'',
        projectid:'',
        stage:'',
        collection_date:'',
        collection_actual:'',
        collectionactualid:''
      },
      dialogVisible1:false,
      rules1: {
        collection_date: [
          { required: true, message: '请选择实际回款时间', trigger: 'change' }
        ],
        collection_actual: [
          { required: true, message: '请输入实际回款金额', trigger: 'change' }
        ],
      },

    //  开票时间
      dialogVisible2:false,
      title2:'',
      form2:{
        projectid:'',
        stage:'',
        collection_amount:'',
        plan_time:''
      },
      title12:'',
      rules2: {
        plan_time: [
          { required: true, message: '请选择开票时间', trigger: 'change' }
        ],
        collection_amount: [
          { required: true, message: '请输入回款金额', trigger: 'change' }
        ],
      },
    }
  },
  methods:{
    //提交
    uodata() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.form.name == '' || this.form.comp == ''){
            this.$message.warning('请完善信息后再提交！')
            return
          }
          if(this.title1 == 'xg'){
            if(this.dialogVisible) {
              let params = {
                projectid: this.form.projectid,
                collectionplanid: this.form.collectionplanid,
                stage: this.form.stage,
                collection_amount: this.form.collection_amount,
                plan_time: this.form.plan_time
              }
              mod_collection_plan(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.$message.success('修改成功')
                  this.getData(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }else{
            if(this.dialogVisible) {
              let params = {
                projectid: this.form.projectid,
                // collectionplanid:this.form.collectionplanid,
                stage: this.form.stage,
                collection_amount: this.form.collection_amount,
                plan_time: this.form.plan_time
              }
              create_collection_plan(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible = false
                  this.$message.success('添加成功')
                  this.getData(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        } else {
          return false;
        }
      });
      //
      //
      // }
    },
    uodata1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          // if(this.form1.name == '' || this.form1.comp == ''){
          //   this.$message.warning('请完善信息后再提交！')
          //   return
          // }
          if(this.form1.title1 == 'xg'){
            if(this.dialogVisible1) {
              let params = {
                projectid: this.form1.projectid,
                collectionactualid: this.form1.collectionactualid,
                stage: this.form1.stage,
                collection_actual: this.form1.collection_actual,
                collection_date : this.form1.collection_date
              }
              mod_collection_actual(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible1 = false
                  this.$message.success('修改成功')
                  this.getData1(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }else{
            if(this.dialogVisible1) {
              let params = {
                projectid: this.form1.projectid,
                // collectionplanid:this.form.collectionplanid,
                stage: this.form1.stage,
                collection_actual: this.form1.collection_actual,
                collection_date : this.form1.collection_date
              }
              create_collection_actual(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible1 = false
                  this.$message.success('添加成功')
                  this.getData1(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        } else {
          return false;
        }
      });
      //
      //
      // }
    },
    comedit2(index, row) {
      if(row != 'new') {
        this.title12 = 'xg'
        this.title2 = '修改回款计划-第'+row.stage+'笔'
        this.form2.projectid = this.project_id
        this.form2.stage = row.stage
        this.form2.collection_amount = row.billing_amount
        this.form2.plan_time = row.invoicing_date
        this.form2.collectionplanid = row.id
        this.dialogVisible2 = true
      }else{
        let weizhi = this.tableData2.length == 0 ? 1 :parseInt(this.tableData2[this.tableData2.length-1].stage)+1
        // console.log(weizhi)
        this.title12 = 'xz'
        this.title2 = '新增回款计划-第'+weizhi+'笔'
        this.form2.projectid = this.project_id
        this.form2.stage = weizhi
        this.form2.collection_amount = ''
        this.form.plan_time2 = ''
        this.dialogVisible2 = true
      }
    },
    uodata2() {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          if(this.form2.name == '' || this.form2.comp == ''){
            this.$message.warning('请完善信息后再提交！')
            return
          }
          if(this.title12 == 'xg'){
            if(this.dialogVisible2) {
              let params = {
                projectid: this.form2.projectid,
                billingid: this.form2.collectionplanid,
                stage: this.form2.stage,
                billing_amount: this.form2.collection_amount,
                invoicing_date: this.form2.plan_time
              }
              mod_billing(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible2 = false
                  this.$message.success('修改成功')
                  this.getData2(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }else{
            if(this.dialogVisible2) {
              let params = {
                projectid: this.form2.projectid,
                // collectionplanid:this.form.collectionplanid,
                stage: this.form2.stage,
                billing_amount: this.form2.collection_amount,
                invoicing_date: this.form2.plan_time
              }
              create_billing(params).then(res => {
                if (res.code === 200) {
                  this.dialogVisible2 = false
                  this.$message.success('添加成功')
                  this.getData2(this.project_id)
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        } else {
          return false;
        }
      });
    },

    delColomn2(id){
      this.$confirm('确定删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            billingid:id
          }
          del_billing(params).then(res => {
            if(res.code == 200){
              this.$message.success('删除成功')
              this.getData2(this.project_id)
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    //删除
    delColomn(id){
      this.$confirm('确定删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            collectionplanid:id
          }
          del_collection_plan(params).then(res => {
            if(res.code == 200){
              this.$message.success('删除成功')
              this.getData(this.project_id)
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    delColomn1(id){
      this.$confirm('确定删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            collectionactualid:id
          }
          del_collection_actual(params).then(res => {
            if(res.code == 200){
              this.$message.success('删除成功')
              this.getData1(this.project_id)
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    //新增或修改 - 计划
    comedit(index, row) {
      if(row != 'new') {
        this.title1 = 'xg'
        this.title = '修改回款计划-第'+row.stage+'笔'
        this.form.projectid = this.project_id
        this.form.stage = row.stage
        this.form.collection_amount = row.collection_amount
        this.form.plan_time = row.plan_time
        this.form.collectionplanid = row.id
        this.dialogVisible = true
      }else{
        this.title1 = 'xz'
        this.title = '新增回款计划-第'+(parseInt(this.tableData.length)+1)+'笔'
        this.form.projectid = this.project_id
        this.form.stage = parseInt(this.tableData.length)+1
        this.form.collection_amount = ''
        this.form.plan_time = ''
        this.dialogVisible = true
      }
    },

    //新增或修改 - 实际
    comedit1(index, row) {
      if(row != 'new') {
        this.form1.title1 = 'xg'
        this.form1.title = '修改实际回款-第'+(row.stage)+'笔'
        this.form1.projectid = this.project_id
        this.form1.stage = row.stage
        this.form1.collection_actual = row.collection_actual
        this.form1.collection_date  = row.collection_date
        this.form1.collectionactualid = row.id
        this.dialogVisible1 = true
      }else{
        // console.log(this.tableData1[this.tableData1.length-1].stage)
        let weizhi = this.tableData1.length == 0 ? 1 :parseInt(this.tableData1[this.tableData1.length-1].stage)+1
        this.form1.title1 = 'xz'
        this.form1.title = '新增实际回款-第'+weizhi+'笔'
        this.form1.projectid = this.project_id
        this.form1.stage = weizhi
        this.form1.collection_actual = ''
        this.form1.collection_date  = ''
        this.form1.collectionactualid = ''
        this.dialogVisible1 = true
      }
    },

    getData(id){
      let paramas = {
        projectid:id
      }
      get_collection_plan(paramas).then(res=>{
        if(res.code == 200){
          this.tableData = res.data
        }
      })
    },
    getData1(id){
      let paramas = {
        projectid:id
      }
      get_collection_actual(paramas).then(res=>{
        if(res.code == 200){
          this.tableData1 = res.data
        }
      })
    },
    getData2(id){
      let paramas = {
        projectid:id
      }
      get_billing(paramas).then(res=>{
        if(res.code == 200){
          this.tableData2 = res.data
        }
      })
    },
  },
  mounted() {
    this.project_id = this.$route.query.id
    this.proname =  this.$route.query.name
    this.getData(this.project_id)
    this.getData1(this.project_id)
    this.getData2(this.project_id)
  }
}
</script>

<style scoped>
.top-div{
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #25396f;
}
.proname{
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 18px;
  margin-bottom: 20px;
  height: 32px;
  line-height: 32px;
}
.hkjh,.kpsj,.sjhk{
  margin-bottom: 50px;
}
.diago >>> .el-dialog{
  min-width: 460px;
}
</style>



// WEBPACK FOOTER //
// src/views/share/hkjh_xq.vue